HM_API = require 'api.coffee'

window.INITIAL_STATE =
  ui:
    online: navigator.onLine
    offline_modal: false

module.exports = ->
  store = {}

  for other_store in ['user_store', 'tr_store', 'accounts_virtuals_store']
    other_store = require("./store/#{other_store}.coffee")
    _.merge store, other_store
    _.merge INITIAL_STATE, other_store.state

  _.merge store,
    strict: false # process.env.NODE_ENV != 'production'
    plugins: [
      require('./store/_helpers.coffee').saveStateToLocalStorage,
      require('./store/_helpers.coffee').displayMutations,
      require('./store/_helpers.coffee').displayActions
    ]
    state: _.clone(INITIAL_STATE)
    mutations:
      RESET_STATE: (state) ->
        state = _.clone(INITIAL_STATE)
        HM.store.replaceState state

    actions:
      setupPolling: (context) ->
        f = ->
          return if _.isEmpty(context.state.user.userdata)
          cache_key = context.state.user.userdata.cache_key
          HM_API.heartbeat(cache_key).then (response) ->
            if response.new_data
              context.commit('Load User Data', response.new_data)
              context.commit('Load Transactions', response.new_data.transactions)

        if process.env.NODE_ENV == 'production'
          setInterval(f, 30*60*1000) # 30 minutes
        else
          setInterval(f, 10*60*1000) # 10 minutes
        setTimeout (-> location.reload()), 120*60*1000 # Reload the page in 120 minutes
